import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export const CompletedTaskIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 14,
  viewBox: "0 0 14 14",
  width: 14,
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14ZM8.93934 5L6.5 7.43934L5.06066 6C4.76777 5.70711 4.29289 5.70711 4 6C3.70711 6.29289 3.70711 6.76777 4 7.06066L6.5 9.56066L10 6.06066C10.2929 5.76777 10.2929 5.29289 10 5C9.70711 4.70711 9.23223 4.70711 8.93934 5Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));
//# sourceMappingURL=completed-task-icon.js.map